<template>
    <div id="app">
    <news></news>
  </div>
</template>

<script>
import News from './components/News'

export default {
  name: 'app',
  components: {
    News
  },
  methods: {
    isPc(){
      return screen.width > 800 ? true: false;
    }
  }

}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// App.vue?2d2380aa